import { createAsyncThunk } from '@reduxjs/toolkit';

import { $api } from '../../../shared/api';
import { getTasksInformation } from '../lib/getTasksInformation';
import { tasksInformationActions } from '../model/slice/tasksInformation';
import { Task } from '../model/types/tasks';
import { TasksData } from '../model/types/tasksInformationSchema';
import { RootState } from '../../../store';

interface FetchTasksError {
    message: string;
}

export const fetchTasks = createAsyncThunk<
    Task[],
    number | undefined,
    { rejectValue: FetchTasksError; state: RootState }
>('tasks/fetchTasks', async (add_gantt = 0, thunkApi) => {
    // @ts-ignore
    const url = routable.getRoute('getTasks');

    try {
        const response = await $api.get<TasksData>(`${url}?add_gantt=${add_gantt}`);

        const { data } = response;
        const { tasks, projects, tags, employees, ...tasksInformation } = data.data;

        const { projectsForFilter, executors } = getTasksInformation(
            tasks,
            projects,
            tags,
            employees
        );

        const { isSorted } = thunkApi.getState().tasksInformationReducer;

        thunkApi.dispatch(
            tasksInformationActions.setTasksInformation({
                ...data.data,
                isLoading: false,
                error: null,
                filteredTabs: null,
                projectsForFilter,
                executorsForFilter: executors,
            })
        );
        thunkApi.dispatch(tasksInformationActions.changeSort(isSorted));

        if (add_gantt) {
            thunkApi.dispatch(tasksInformationActions.changeNeedGantt());
            thunkApi.dispatch(tasksInformationActions.setShowGanttTabs(true));
        }

        return tasks;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});
